module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/fraternity-1-medium-37c562027cd87b6997f705972cc30f5e.jpg";